import Vue from "vue";

Vue.filter('nullify', function (value) {
    return value || '-';
});
